import { defineStore } from 'pinia'
import { ref } from 'vue'
import { walletAPIServiceV2 } from '@/networks/api/v2/wallet-api.service'
import type { Maybe } from '@/types'

const useAccountBalanceAPIStore = defineStore('accountBalanceAPI', () => {
  const accountBalanceList = ref<Record<string, string>>({})
  const accountTokenBalanceList = ref<
    Record<string, Maybe<Record<string, string>>>
  >({})

  /**
   * 여러 account의 balance를 한 번에 조회
   */
  const fetchAccountBalances = async (accountIds: string[]) => {
    if (!accountIds || accountIds.length === 0) return

    try {
      // V2: /wallet/account/balance API 호출 (여러 accountId 한 번에)
      const balanceRes = await walletAPIServiceV2.getAccountBalances(accountIds)

      // V2 응답: { accounts: [{ id, balance, ... }] }
      if (balanceRes?.accounts && Array.isArray(balanceRes.accounts)) {
        for (const account of balanceRes.accounts) {
          const accountId = account.id
          accountBalanceList.value[accountId] = account.balance || '0'

          // TODO: 토큰 balance는 별도 API 또는 accountData.childAccount에서 가져와야 함
        }
      }
    } catch (error) {
      // Error handled silently
    }
  }

  /**
   * 단일 account의 balance 조회 (하위 호환용)
   */
  const fetchAccountBalance = async ({
    accountId,
    force = false,
  }: {
    accountId: string
    force?: boolean
  }) => {
    if (!force && accountBalanceList.value[accountId]) {
      return
    }
    await fetchAccountBalances([accountId])
  }

  const reset = () => {
    accountBalanceList.value = {}
    accountTokenBalanceList.value = {}
  }

  return {
    accountBalanceList,
    accountTokenBalanceList,
    fetchAccountBalance,
    fetchAccountBalances,
    reset,
  }
})

export { useAccountBalanceAPIStore }
